export default __webpack_public_path__ + "static/withings-f5605f049d6a2e64bfc98e690d994c92.png";